<script>
import PageHeader from "@/components/page-header.vue";
import add from "@/views/pages/Dilfoods/options_groups/add.vue";
import Layout from "@/views/layouts/main.vue";
import axios from "axios";
import { OpsPath } from "@/path";
import Opg_up_push from "@/views/pages/Dilfoods/options_groups/opg_up_push.vue";
import EditIcon from "@/views/pages/Dilfoods/Common/icons/EditIcon.vue";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";
import UploadIcon from "@/views/pages/Dilfoods/Common/icons/UploadIcon.vue";

export default {
  components: {
    Opg_up_push,
    Layout,
    add,
    PageHeader,
    EditIcon,
    DeleteIcon,
    UploadIcon,
  },
  data() {
    return {
      title: "Modifier Groups",
      items: [
        {
          text: "List",
        },
        {
          text: "Modifier Group",
          active: true,
        },
      ],
      selectedOpG: null,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      opgs: [],
      fields: ["title", "description", "modifier_type", "Locations", "actions"],
      key: 0,
      filter: [],
      current_page: 1,
      search: "",
    };
  },
  watch: {
    current_page() {
      this.getOps();
    },
    search() {
      this.getOps();
    },
  },
  mounted() {
    this.getOps();
  },
  methods: {
    reload() {
      this.getOps();
    },
    setEdit(v) {
      this.addModifier();
      this.selectedOpG = v;
      this.key += 1;
    },
    addModifier() {
      this.$bvModal.show("bv-add-options-group");
    },
    uploadToUP(v) {
      this.selectedOpG = v;
      this.key += 1;
      this.$bvModal.show("bv-upload-opg");
    },
    async getOps() {
      try {
        let res = await axios.get(this.base_url + OpsPath.GETOPGS, {
          params: {
            page: this.current_page,
            search: this.search,
          },
        });
        if (res.data.status) {
          this.opgs = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button
                  @click="addModifier()"
                  class="btn btn-primary mb-10 pb-10"
                  >Add Modifier Groups</b-button
                >
                <b-modal
                  id="bv-add-options-group"
                  :title="
                    selectedOpG &&
                    (Object.keys(selectedOpG).length > 0 ? 'Edit' : 'Add') +
                      ' Modifier Group'
                  "
                  hide-footer
                >
                  <add
                    @update="reload()"
                    :key="key"
                    :selected_op_g="selectedOpG"
                  ></add>
                </b-modal>
                <b-modal
                  id="bv-upload-opg"
                  title="Upload to urban piper"
                  hide-footer
                >
                  <Opg_up_push :key="key" :opg="selectedOpG"></Opg_up_push>
                </b-modal>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <div class="pb-2 float-right w-25">
                <b-row>
                  <b-col sm="12">
                    <b-input-group size="sm">
                      <b-input-group-prepend is-text>
                        <i class="fa fa-search"></i>
                      </b-input-group-prepend>
                      <b-input
                        size="sm"
                        debounce="300"
                        placeholder="Search"
                        v-model="search"
                      ></b-input>
                    </b-input-group>
                  </b-col>
                </b-row>
              </div>
              <b-table
                :key="opgs.key"
                :items="opgs.data"
                :fields="fields"
                responsive="sm"
                :per-page="opgs.per_page"
                :filter="filter"
                :current-page="current_page"
              >
                <template v-slot:cell(modifier_type)="row">
                  <b-tag v-if="row.item.is_variant == false">Add On</b-tag
                  ><b-tag v-else>Variant</b-tag>
                </template>
                <template v-slot:cell(locations)="row">
                  <template v-if="row.item.locations">
                    <b-tag v-for="(l, li) in row.item.locations" :key="li"
                      >{{ l.name }} - {{ l.ref_id }}</b-tag
                    >
                  </template>
                </template>
                <template v-slot:cell(actions)="row">
                  <div style="display: flex; gap: 0px">
                    <div @click="uploadToUP(row.item)">
                      <UploadIcon :title="'Update to urban piper'" />
                    </div>
                    <div @click="setEdit(row.item)">
                      <EditIcon />
                    </div>
                    <div @click="deleteData(row.item)">
                      <DeleteIcon />
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="opgs.key"
                      v-model="opgs.current_page"
                      :total-rows="opgs.total"
                      :per-page="opgs.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped></style>
